import { render, staticRenderFns } from "./OrderColumnItem.vue?vue&type=template&id=76bc0ed7&"
import script from "./OrderColumnItem.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports